'user strict'
const { nextTick } = require('process')
const ex = require('../lib/error')
const expenses = require('../models').expenses
const invoices = require('../models').invoices
const users = require('../models').users
const masterItems = require('../models').masterItems
const sequelize = require('sequelize')
const Op = sequelize.Op

const getdayBook = (req,res,next) =>{

}

